import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Package, ArrowRight } from "lucide-react";
import Skeleton from "@/components/Skeleton";

export default function NewProductsPage() {
    const [products, setProducts] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/products", { params: { in_stock_only: true, per_page: 24 } });
                setProducts(data);
            } catch {
                setProducts([]);
            }
        })();
    }, []);

    return (
        <div className="bg-white min-h-[60vh]" data-testid="new-products-page">
            <div className="border-b border-slate-200 bg-slate-50/60">
                <div className="max-w-[1440px] mx-auto px-4 py-6">
                    <div className="label-kicker mb-1">Just Arrived</div>
                    <h1 className="font-display font-black text-3xl md:text-4xl uppercase">New products</h1>
                </div>
            </div>

            <div className="max-w-[1440px] mx-auto px-4 py-8">
                {products === null ? (
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        {Array.from({ length: 8 }).map((_, i) => (
                            <Skeleton key={i} className="aspect-square" />
                        ))}
                    </div>
                ) : products.length === 0 ? (
                    <div className="border border-slate-200 p-12 text-center">
                        <p className="font-mono text-slate-500">No new products in stock right now.</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        {products.map((p, i) => (
                            <Link
                                key={p.id}
                                to={`/product/${p.id}`}
                                className="card-sharp group fade-in-up"
                                style={{ animationDelay: `${Math.min(i * 30, 400)}ms` }}
                            >
                                <div className="aspect-square bg-slate-50 overflow-hidden">
                                    {p.image_url ? (
                                        <img src={p.image_url} alt={p.name} className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300" />
                                    ) : (
                                        <div className="w-full h-full flex items-center justify-center text-slate-300">
                                            <Package className="w-16 h-16" />
                                        </div>
                                    )}
                                </div>
                                <div className="p-3 border-t border-slate-200">
                                    <div className="font-display font-bold text-sm uppercase clamp-2 group-hover:text-[hsl(var(--primary))]">
                                        {p.name}
                                    </div>
                                    <div className="font-mono text-[11px] text-slate-500 mt-1 flex items-center justify-between">
                                        <span>{p.category_name}</span>
                                        <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
